/**
 * 官网常见问题（匿名接口，与 beauty-ui 后台同源）
 * @returns {Promise<Array>}
 */
export function fetchPublicFaqList() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/faq/public/list', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return Array.isArray(body.data) ? body.data : []
    })
}
